<template>
  <!-- 联系客服 -->
  <div class="connect">
    <div class="top">
      <div class="title">广告服务</div>
      <!--<div class="info">联系客服</div>--><div class="line"></div>
    </div>
    <div class="wechat">
      <!--<span>扫描下方二维码联系客服</span>-->
      <!-- <img src="../../assets/serve/pic_lxkf@2x.png" alt="" class="image" /> -->
      <img :src="qrcode | urlLoad" alt="" class="image" />

      <!-- <span>联系电话：{{ phone }}</span> -->
    </div>
	<div class="massage-top">
	<div class="massage">
		<span>联系我们</span>
	</div>
	<div class="line2">
	</div>
	<div class="home_right">
<img src="https://yousubao.oss-cn-shenzhen.aliyuncs.com/head/jpg/2024-12-13/96f19d9a1b6880a50890582ca4d55d4.jpg" alt="" style="width: 2rem;height: 2rem;" />
<p style="margin-top: 0.1rem;">客服微信</p>
	</div>
	</div>
	
	
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      qrcode: "",
    };
  },
  created() {
    this.connectServices();
  },
  methods: {
    async connectServices() {
      let params = {};
      let res = await this.$apiFun.connectServices(params);
      // this.supportList = res.result.rows;
      if (res.code == 200) {
        this.phone = res.result.hotline;
        this.qrcode = res.result.customerServiceQrCode;
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === from.path) {
        this.fetchImageUrl();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.connect {
  width: 95%;
  height: 96%;
  background: #fff;
  padding-top: 0.3rem;
  padding-left: 0.5rem;
  .top {
    font-family: Microsoft YaHei;
    text-align: left;
    .title {
      font-size: 0.24rem;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0.3rem;
    }
    .info {
      font-size: 0.18rem;
      font-weight: 400;
      color: #666666;
      margin-bottom: 1rem;
    }
  }
  .line {
      height: 2px;
      background: #efefef;
      margin: 0.3rem 0;margin-right: 0.5rem;
    }
	
  .wechat {
	position: relative;
    flex-direction: column;
    align-items: center;
    .image {
	position: absolute;
      width: 9rem;
      height: 4.5rem;
      right: 1.3rem;
top: 0.2rem;
box-shadow: 2px 2px 4px #666666;
    }
  }
  .massage-top{
width: 95%;
height: 96%;
float: left;
margin-top: 5.5rem;
  .massage{
font-size: 0.24rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  float: left;
  line-height: 0.3rem;
  }
  .line2 {
      height: 2px;
      background: #efefef;
margin: 0.6rem 0;margin-right: 0.5rem;
    }
	.home_right{
	font-size: 0.22rem;
	font-family: Microsoft YaHei;
	color: #333333;
	margin-right: 0.7rem;
	margin-top: -0.1rem;
		}
	}
	
}
</style>